import styled from 'styled-components'

import { helpers } from 'styles'

import { IconCheckPlain } from 'components/Icons'

type Props = {
	isChecked: boolean
}

export const Check = styled(IconCheckPlain)<Props>`
	width: ${helpers.font.size.icon};
	height: ${helpers.font.size.icon};
	vertical-align: middle;

	color: ${helpers.color.icon};

	opacity: ${({ isChecked }) => (isChecked ? 1 : 0)};

	transition: opacity 0.2s;
`
